"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargePointIdentifier = void 0;
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
/**
 * Validates on the following properties:
 * - Is string
 * - Length of 14
 * - Matches the pattern of NLESSE followed by 8 digits
 */
const ChargePointIdentifier = () => (0, base_models_1.combineDecorators)((0, class_validator_1.IsString)(), (0, base_models_1.ExactLength)(14), (0, class_validator_1.Matches)(/NLESSE[0-9]{8}/));
exports.ChargePointIdentifier = ChargePointIdentifier;
